module.exports = __webpack_public_path__ + "static/media/foot.95070381.obj";